/* Atelea search routing. Full results stay scoped to products. */

const PREDICTIVE_FORM_SELECTOR = '.predictive-search-form';
const PREDICTIVE_INPUT_SELECTOR = '.search-input';

/**
 * Navigate to the product-scoped search route.
 * @param {HTMLFormElement} form - The predictive search form.
 * @param {string} query - The submitted search term.
 * @returns {void}
 */
const navigateToProductSearch = (form, query) => {
  const formAction = form.getAttribute('action') || window.Theme?.routes?.search_url;
  if (!formAction || !query) return;

  const searchUrl = new URL(formAction, window.location.origin);
  searchUrl.searchParams.set('q', query);
  searchUrl.searchParams.set('type', 'product');
  window.location.assign(searchUrl.toString());
};

/**
 * Keep the predictive modal cross-resource while scoping its full result route to products.
 * @param {SubmitEvent} event - The predictive form submit event.
 * @returns {void}
 */
const handlePredictiveSubmit = (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches(PREDICTIVE_FORM_SELECTOR)) return;

  const input = form.querySelector(PREDICTIVE_INPUT_SELECTOR);
  if (!(input instanceof HTMLInputElement)) return;

  const query = input.value.trim();
  if (!query) return;

  event.preventDefault();
  navigateToProductSearch(form, query);
};

/**
 * Match native predictive search Enter behavior when no result is selected.
 * @param {KeyboardEvent} event - The predictive search keyboard event.
 * @returns {void}
 */
const handlePredictiveKeydown = (event) => {
  if (event.key !== 'Enter' || event.isComposing) return;

  const input = event.target;
  if (!(input instanceof HTMLInputElement) || !input.matches(PREDICTIVE_INPUT_SELECTOR)) return;

  const form = input.form;
  if (!(form instanceof HTMLFormElement) || !form.matches(PREDICTIVE_FORM_SELECTOR)) return;
  if (form.querySelector('[aria-selected="true"]')) return;

  const query = input.value.trim();
  if (!query) return;

  event.preventDefault();
  event.stopPropagation();
  navigateToProductSearch(form, query);
};

document.addEventListener('submit', handlePredictiveSubmit, true);
document.addEventListener('keydown', handlePredictiveKeydown, true);
